module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterIcon@3x-858ccd5003bbded9c6700289baaaca32.png";